import React, { useContext, useState, useEffect, useCallback } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { NavLink, useLocation, useHistory } from 'react-router-dom'
import { ExternalLink, MEDIA_WIDTHS } from '../../theme'
import { stopPropagation } from '../../utils/func'
import LimitIp from '../../pages/LimitIp'
import CheckTest from '../../pages/CheckTest'
import ReactDOM from 'react-dom'
import { memeList, partnerList, gameList, CollectionArr } from '../../constants/nft'
import { getArtist } from '../../service/user'
import { useActiveWeb3React } from '../../hooks'
import { userInfo } from '../../constants/usercenter'
import { userInfoProps } from '../../constants/usercenter'
import { useDarkModeManager } from '../../state/user/hooks'

import Home_select from '../../assets/svg/home_select.svg'
import Home from '../../assets/svg/home.svg'
import Earning_select from '../../assets/svg/earning_select.svg'
import Earning from '../../assets/svg/earning.svg'
import Trade from '../../assets/svg/trade.svg'
import Nft from '../../assets/svg/nft.svg'
// import Launchpad_select from '../../assets/svg/launchpad_select.svg'
// import Launchpad from '../../assets/svg/launchpad.svg'
import Eth_select from '../../assets/svg/eth_select.svg'
import Eth from '../../assets/svg/eth.svg'
import Game_select from '../../assets/svg/game_select.svg'
import Game from '../../assets/svg/game.svg'
import Info from '../../assets/svg/info.svg'
import Triangle_down from '../../assets/svg/triangle_down.svg'
import Triangle_up from '../../assets/svg/triangle_up.svg'
import Contact from '../../assets/svg/contact.svg'
import Gallery from '../../assets/svg/gallery.svg'
// import BakeAi from '../../assets/svg/bake_ai.svg'
import Liquidity_select from '../../assets/svg/liquidity_select.svg'
import Liquidity from '../../assets/svg/liquidity.svg'
import Exchange_select from '../../assets/svg/exchange_select.svg'
import Exchange from '../../assets/svg/exchange.svg'
import Medium from '../../assets/svg/medium.svg'
import Twitter from '../../assets/svg/twitter.svg'
import Explore_select from '../../assets/svg/explore_select.svg'
import Explore from '../../assets/svg/explore.svg'
import GameNft_select from '../../assets/svg/gameNft_select.svg'
import GameNft from '../../assets/svg/gameNft.svg'
import Meme_select from '../../assets/svg/meme_select.svg'
import Meme from '../../assets/svg/meme.svg'
import Artists_select from '../../assets/svg/artists_select.svg'
import Artists from '../../assets/svg/artists.svg'
import Partner_select from '../../assets/svg/partner_select.svg'
import Partner from '../../assets/svg/partner.svg'
import TopNft_select from '../../assets/svg/topNft_select.svg'
import TopNft from '../../assets/svg/topNft.svg'
import Triangle_left from '../../assets/svg/triangle_left.svg'
import Triangle_right from '../../assets/svg/triangle_right.svg'

import Artists_dark from '../../assets/svg/artists_dark.svg'
import Contact_dark from '../../assets/svg/contact_dark.svg'
import Earning_dark from '../../assets/svg/earning_dark.svg'
import Exchange_dark from '../../assets/svg/exchange_dark.svg'
import Explore_dark from '../../assets/svg/explore_dark.svg'
import Game_dark from '../../assets/svg/game_dark.svg'
import GameNft_dark from '../../assets/svg/gameNft_dark.svg'
import Home_dark from '../../assets/svg/home_dark.svg'
import Info_dark from '../../assets/svg/info_dark.svg'
// import Launchpad_dark from '../../assets/svg/launchpad_dark.svg'
import Medium_dark from '../../assets/svg/mediumdark.svg'
import Liquidity_dark from '../../assets/svg/liquidity_dark.svg'
import Meme_dark from '../../assets/svg/meme_dark.svg'
import Nft_dark from '../../assets/svg/nft_dark.svg'
import Partner_dark from '../../assets/svg/partner_dark.svg'
import TopNft_dark from '../../assets/svg/topNft_dark.svg'
import Trade_dark from '../../assets/svg/trade_dark.svg'
import Twitter_dark from '../../assets/svg/twitter_dark.svg'

const activeClassName = 'ACTIVENAV'
const galleryAboutLink = "galleryAboutLink"
const bakeAiAboutLink = "bakeAiAboutLink"
const contactClassName = "ACTIVECALSS"
const nftClassName = 'NFTCLASS'

const NavElement = styled.nav`
  width: 268px;
  height: calc(100vh - 61px);
  overflow: auto;
  
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.16);
  background: ${({ theme }) => theme.bsBg36};
  position: relative;
  z-index: 1;

  &.${activeClassName}{
    ${({ theme }) => theme.mediaWidth.upToMedium`
    &:before{
        content: "";
        position: fixed;
        width: 100vw;
        height: 100vh;
        z-index: -2;
        background: rgba(0,0,0,0.3);
    }
    &:after{
      content: "";
      position: fixed;
      width: 268px;
      z-index: -1;
      background: ${({ theme }) => theme.bsBg36};
      left: 0px;
      height: calc(100vh - 61px);
      top: 61px;
    }
  `};
  }


  ${({ theme }) => theme.mediaWidth.upToSmall`
    overflow-x: auto;
  `};
`

const NavItem = styled(NavLink).attrs({
  activeClassName
})`
  position: relative;
  color: ${({ theme }) => theme.bsText20};
  text-decoration: none;
  white-space:nowrap;
  display:block;
  padding: 0px 20px;
  height: 54px;
  line-height: 54px;
  margin: 10px 0px;

  &:hover{
    background: linear-gradient(305.04deg, #fff6b3 -43.12%, #ffb067 70.33%);
  }

  &.${activeClassName} {
    color: ${({ theme }) => theme.bsText39};
    background: linear-gradient(305.04deg, #FFD600 -43.12%, #FF7A00 70.33%);
    position: relative;
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 0;
  `};
`

const NavBarItem = styled.div.attrs({
  activeClassName
})`
  cursor: pointer;
  position: relative;
  color: ${({ theme }) => theme.bsText20};
  text-decoration: none;
  white-space:nowrap;
  display:block;
  padding: 0px 20px;
  height: 54px;
  line-height: 54px;
  margin: 10px 0px;
  font-weight: 500;

  &:hover{
    background: linear-gradient(305.04deg, #fff6b3 -43.12%, #ffb067 70.33%);
  }

  &.${activeClassName} {
    color: ${({ theme }) => theme.bsText21};
    background: linear-gradient(305.04deg, #FFD600 -43.12%, #FF7A00 70.33%);
    position: relative;
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 0;
  `};
`
const AboutLink = styled(ExternalLink)`
  color: ${({ theme }) => theme.bsText20};
  font-weight: bold;
  text-decoration: none;
  display:block;
  padding: 0px 20px;
  height: 54px;
  line-height: 54px;
  margin: 10px 0px;
  white-space:nowrap;

  &:hover{
    background: linear-gradient(305.04deg, #fff6b3 -43.12%, #ffb067 70.33%);
  }

  &.${galleryAboutLink}{
    padding-left: 54px;
    height: 50px;
    line-height: 50px;
    color: inherit;
    display: inline;
    padding: 0px;
    margin-left: 8px;
    color: ${({ theme }) => theme.bsText40};
    &:hover{
      color: #ffffff;
    }
  }

  &.${bakeAiAboutLink}{
    padding-left: 54px;
    height: 50px;
    line-height: 50px;
    color: inherit;
    display: inline;
    padding: 0px;
    margin-left: 8px;
    color: ${({ theme }) => theme.bsText45};
    &:hover{
      color: #ffffff;
    }
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 0;
    margin-right: 8px;
  `};
`

const TriggerMenu = styled.div`
    position: relative;
    color: ${({ theme }) => theme.bsText20};
    font-weight: bold;
    text-decoration: none;
    white-space:nowrap;
    display:block;
    padding: 0px 20px;
    height: 54px;
    line-height: 54px;
    cursor: pointer;
    &:hover{
      background: linear-gradient(305.04deg, #fff6b3 -43.12%, #ffb067 70.33%);
    }
`

const MenuElement = styled.div` 
  background: ${({ theme }) => theme.bsBg31};
  overflow: hidden;
  transition: height .3s linear;
  height: 0px;
  border: 0px;
  box-shadow: 0px 2px 8px rgba(171, 133, 115, 0.16) inset;
  &.${activeClassName} {
    height: 138px;
  }
  &.${contactClassName} {
    height: 202px;
  }
  &.${nftClassName} {
    height: 330px;
    overflow: auto;
  }
`

const IconNav = styled.img`
  vertical-align: middle;
`
const galleryNewIcon = "galleryNewIcon"
const bakeAiIcon = "bakeAiIcon"
const IconNew = styled.img`
  position: absolute;
  top: 12px;
  right: 30px;
  &.${galleryNewIcon}{
    right: 48px;
  }
  &.${bakeAiIcon}{
    left: 100px!important;
    top: 5px!important;
  }
`

const IconTriangle = styled.img`
  position: absolute;
  right: 12px;
  top: 8px;
  bottom: 0px;
  margin: auto;
`

const TextTitle = styled.span`
  margin-left: 8px;
  vertical-align: middle;
`

const NewGallery = styled.div`
  color: ${({ theme }) => theme.bsText19};
  position: relative;
  font-weight: bold;
  text-decoration: none;
  white-space:nowrap;
  display:block;
  padding: 0px 20px;
  height: 54px;
  line-height: 54px;
  &:hover{
    background: linear-gradient(305.04deg, #fff6b3 -43.12%, #ffb067 70.33%);
  }
`

const CollectionList = styled.div`
  width: 244px;
  background: ${({ theme }) => theme.bsBg31};
  box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.16);
  height: calc(100vh - 62px);
  overflow: auto;
  color: ${({ theme }) => theme.bsText20};
  transition: width 0.1s linear;
  &.hideCollectionList{
    width: 0px;
    overflow: hidden;
  }
`

const CollectionTitle = styled.div`
  
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: flex-start;
  padding-bottom: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.bsBorder2};
  box-sizing: border-box;
  padding: 20px;
`

const IconExpand = styled.img`
  margin-top: 8px;
  cursor: pointer;
`
const NftList = styled.div`
  padding: 0px 20px;
  box-sizing: border-box;
  &.phoneNft{
    padding-left: 44px;
  }
`
const NftItem = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0px;
  height: 38px;
  line-height: 38px;
  border-radius: 50px;
  padding: 8px 13px;
  box-sizing: border-box;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  min-width: 204px;
  &:hover{
    background: linear-gradient(305.04deg, #fff6b3 -43.12%, #ffb067 70.33%);
  }
  &.selectNftItem{
    color: #ffffff;
    background: linear-gradient(285.72deg, #FFD600 -21.15%, #FF7A00 60.61%);
  }
`
const ItemIcon = styled.img`
  width: 23px;
  height: 23px;
  border-radius: 100%;
`

const ItemText = styled.div`
  margin-left: 8px;
  line-height: 15px;
  word-break: break-all;
`

export default function Nav({ triggerFold, isFold }: { triggerFold: (fold: boolean) => void, isFold: boolean }) {
  const [isDark] = useDarkModeManager()
  
  const location = useLocation()
  const { chainId } = useActiveWeb3React()
  
  const [artistData, setArtistData] = useState<any[]>([])
  const [collectionData, setCollectionData] = useState<any[]>([])
  const [collectionTitle, setCollectionTitle] = useState<string>('')
  const [collectionIndex, setCollectionIndex] = useState<number>(0)
  const [hideCollection, setHideCollection] = useState<boolean>(true)
  
  const theme = useContext(ThemeContext)

  const [isTrade, setIsTrade] = useState(true)
  const [isShowNft, setIsShowNft] = useState(true)
  const [isContact, setIsContact] = useState(true)

  useEffect(() => {
    const wrapper = document.createElement('div')
    ReactDOM.render(<LimitIp/>, wrapper)
    document.body.appendChild(wrapper)
    if (window.location.host.indexOf('bakeryswap.io') >= 0) {
      const wrapper = document.createElement('div')
      ReactDOM.render(<CheckTest/>, wrapper)
      document.body.appendChild(wrapper)
    }
    if(location.pathname === '/swap' || location.pathname === '/pool'){
        setIsTrade(true)
    }
  }, [location.pathname])

  const triggerTrade = (trade: boolean, event: any) => {
    stopPropagation(event)
    isFold ? setIsTrade(true) : setIsTrade(trade)
    triggerFold(false)
  }

  const triggerContact = (contact: boolean, event: any) => {
    stopPropagation(event)
    isFold ? setIsContact(true) : setIsContact(contact)
    triggerFold(false)
  }

  const triggerNft = (isShowNft: boolean, event: any) => {
    stopPropagation(event)
    isFold ? setIsShowNft(true) : setIsShowNft(isShowNft)
    triggerFold(false)
  }

  // 获取艺术家数据
  const getArtistList = useCallback(() => {
    getArtist(chainId as number, {addressTypes: '4'}, (err: any, d: any) => {
      if (!err && d.code === 0) {
        const list = d.data || []
        const data = list.length ? list : userInfo
        const artists = data.map((d: userInfoProps) => {
          return{
            nick: d.nick,
            avatar: d.avatar,
            address: d.address
          }
        })
        setArtistData(artists)
      } else {
        setArtistData(userInfo as any)
      }
    })
  }, [chainId])

  useEffect(() => {
    getArtistList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chainId,getArtistList])

  // nft菜单点击获取collection数据
  const goCollectionList = useCallback((index, event) => {
    stopPropagation(event)
    let title = ''
    let list = [] 
    switch(index){
      case 1:
        title = 'Featured Artists'
        list = artistData
        break
      case 2:
        title = 'Open Market'
        list = memeList
        break
      case 3:
        title = 'Partner Shops'
        list = partnerList
        break
      case 4:
        title = 'Collectibles and Game Assets'
        list = gameList
        break
    }
    setCollectionTitle(title)
    setCollectionData(list)
    // 展开集合列表
    if(document.body.offsetWidth <= +MEDIA_WIDTHS.upToMedium){
      // 手机端隐藏
      triggerFold(false)
      setHideCollection(true)
      collectionIndex === index ? setCollectionIndex(0) : setCollectionIndex(index)
    }else {
      collectionIndex === index ? setCollectionIndex(0) : setCollectionIndex(index)
      collectionIndex === index ? setHideCollection(true) : setHideCollection(false)
    }
  }, [artistData, memeList, partnerList, gameList, collectionIndex])

  const goExplore = () => {
    setHideCollection(true)
    setCollectionIndex(0)
    history.push(`/explore`)
  }

  // 隐藏集合列表
  const hideCollectionFn = () => {
    setHideCollection(true)
    setCollectionIndex(0)
  }

  // 进入个人中心
  const history = useHistory();
  const goNftCollection = useCallback((address: string, nftType: string, event:any) => {
    stopPropagation(event)
    if (address) {
      history.push(`/usercenter/${address}?type=CREATED`)
    } else {
      const [activeUrl] = CollectionArr.filter((d: any) => {
        if (!d.nftType) return
        if (d.nftType === nftType) {
          return d
        }
      })
      const urlName = activeUrl.urlName
      history.push(`/collection/${urlName}`)
    }
    setHideCollection(true)
    setCollectionIndex(0)
    document.body.offsetWidth <= +MEDIA_WIDTHS.upToMedium && triggerFold(true)
  }, [history])

  const hiddenNftCollection = (e:any) => {
    stopPropagation(e)
    setHideCollection(true)
    setCollectionIndex(0)
  }


  return (
    <>
      <NavElement className={!isFold ? activeClassName : ''} onClick={document.body.offsetWidth <= +MEDIA_WIDTHS.upToMedium ? triggerFold.bind(null, !isFold) : () => { }}>
        <NavItem onClick={(e) => { hiddenNftCollection(e) }} to={'/home'} className={location.pathname === '/home' ? activeClassName : ''}>
          <IconNav src={location.pathname === '/home' ? Home_select : isDark ? Home_dark : Home} style={{ height: 24 }} />
          {
            !isFold && (
              <TextTitle>Home</TextTitle>
            )
          }
        </NavItem>
        {/* <NewGallery>
          <IconNav src={BakeAi} style={{ height: 24 }} />
          {
            !isFold && (
              <AboutLink href={'https://www.bakeai.world/'} className={bakeAiAboutLink}>BakeAI</AboutLink>
            )
          }
          {
            !isFold && (
              <IconNew className="bakeAiIcon" src={'/images/icon_ai_new.svg'} width={24} />
            )
          }
        </NewGallery> */}
        <TriggerMenu onClick={(e) => { triggerTrade(!isTrade, e) }} className={isTrade ? activeClassName : ''}>
          <IconNav src={isDark ? Trade_dark : Trade} style={{ height: 24 }} />
          {
            !isFold && (
              <>
                <TextTitle>Trade</TextTitle>
                <IconTriangle src={!isTrade ? Triangle_up :  Triangle_down} style={{ height: 8 }} />
              </>
            )
          }
        </TriggerMenu>
        {
          !isFold && (
            <MenuElement className={isTrade ? activeClassName : ''}>
              <NavItem onClick={(e) => { hiddenNftCollection(e) }} to={'/swap'} className={location.pathname === '/swap' ? activeClassName : ''} style={{ paddingLeft: '54px', fontWeight: 500}}>
                <IconNav src={location.pathname === '/swap' ? Exchange_select : isDark ? Exchange_dark : Exchange} style={{ height: 24 }} />
                <TextTitle>Exchange</TextTitle>
              </NavItem>
              <NavItem onClick={(e) => { hiddenNftCollection(e) }} to={'/pool'} className={location.pathname === '/pool' ? activeClassName : ''} style={{ paddingLeft: '54px', fontWeight: 500 }}>
                <IconNav src={location.pathname === '/pool' ? Liquidity_select : isDark ? Liquidity_dark : Liquidity} style={{ height: 24 }} />
                <TextTitle>Liquidity</TextTitle>
              </NavItem>
            </MenuElement>
          )
        }
        <NavItem onClick={(e) => { hiddenNftCollection(e) }} to={'/bakery'} className={location.pathname === '/bakery' ? activeClassName : ''}>
          <IconNav src={location.pathname === '/bakery' ? Earning_select : isDark ? Earning_dark : Earning} style={{ height: 24 }} />
          {
            !isFold && (
              <TextTitle>Earning</TextTitle>
            )
          }
        </NavItem>
        <TriggerMenu onClick={(e) => { triggerNft(!isShowNft, e) }} className={isShowNft ? activeClassName : ''}>
          <IconNav src={isDark ? Nft_dark : Nft} style={{ height: 24 }} />
          {
            !isFold && (
              <>
                <TextTitle>NFT Marketplace</TextTitle>
                <IconTriangle src={!isShowNft ? Triangle_up : Triangle_down} style={{ height: 8 }} />
              </>
            )
          }
        </TriggerMenu>
        {
          !isFold && (
            <MenuElement className={isShowNft ? nftClassName : ''}>
              <NavBarItem onClick={() => goExplore()} className={false ? activeClassName : ''} style={{ paddingLeft: '54px' }}>
                <IconNav src={false ? Explore_select : isDark ? Explore_dark : Explore} style={{ height: 24 }} />
                <TextTitle>Explore</TextTitle>
              </NavBarItem>
              {
                false && (
                  <NavBarItem className={false ? activeClassName : ''} style={{ paddingLeft: '54px' }}>
                    <IconNav src={false ? TopNft_select : isDark ? TopNft_dark : TopNft} style={{ height: 24 }} />
                    <TextTitle>Top NFTs</TextTitle>
                  </NavBarItem>
                )
              }
              <NavBarItem onClick={(e) => goCollectionList(1, e)} className={collectionIndex === 1 ? activeClassName : ''} style={{ paddingLeft: '54px' }}>
                <IconNav src={collectionIndex === 1 ? Artists_select : isDark ? Artists_dark : Artists} style={{ height: 24 }} />
                <TextTitle>Featured Artists</TextTitle>
                {
                  collectionIndex === 1 ?  (
                    document.body.offsetWidth <= +MEDIA_WIDTHS.upToMedium ? (
                      <IconTriangle src={Triangle_down} style={{ height: 8 }} />
                    ) : (
                      <IconTriangle src={Triangle_right} style={{ height: 8 }} />
                    )
                  )
                  : (
                    document.body.offsetWidth <= +MEDIA_WIDTHS.upToMedium ? (
                      <IconTriangle src={Triangle_up} style={{ height: 8 }} />
                    ) : (
                      <IconTriangle src={Triangle_left} style={{ height: 8 }} />
                    )
                  )
                }
              </NavBarItem>
              {
                collectionIndex === 1 && document.body.offsetWidth <= +MEDIA_WIDTHS.upToMedium && (
                  <NftList className={'phoneNft'}>
                    {
                      collectionData.map((d , index) => {
                        return (
                          <NftItem 
                            key={index} 
                            onClick={(e) => { goNftCollection(d.address, d.nftType, e) }} 
                            className={(d.address && location.pathname.includes(d.address)) || (d.urlName && location.pathname === `/collection/${d.urlName}`) ? 'selectNftItem' : ''}
                          >
                            {
                              d.avatar && <ItemIcon src={d.avatar}/>
                            }
                            <ItemText>{d.nick}</ItemText>
                          </NftItem>
                        )
                      })
                    }
                  </NftList>
                )
              }
              <NavBarItem onClick={(e) => goCollectionList(2, e)} className={collectionIndex === 2 ? activeClassName : ''} style={{ paddingLeft: '54px' }}>
                <IconNav src={collectionIndex === 2 ? Meme_select : isDark ? Meme_dark : Meme} style={{ height: 24 }} />
                <TextTitle>Open Market</TextTitle>
                {
                  collectionIndex === 2 ?  
                  document.body.offsetWidth <= +MEDIA_WIDTHS.upToMedium ? (
                    <IconTriangle src={Triangle_down} style={{ height: 8 }} />
                  ) : (
                    <IconTriangle src={Triangle_right} style={{ height: 8 }} />
                  )
                  : document.body.offsetWidth <= +MEDIA_WIDTHS.upToMedium ? (
                    <IconTriangle src={Triangle_up} style={{ height: 8 }} />
                  ) : (
                    <IconTriangle src={Triangle_left} style={{ height: 8 }} />
                  )
                }
              </NavBarItem>
              {
                collectionIndex === 2 && document.body.offsetWidth <= +MEDIA_WIDTHS.upToMedium && (
                  <NftList className={'phoneNft'}>
                    {
                      collectionData.map((d , index) => {
                        return (
                          <NftItem 
                            key={index} 
                            onClick={(e) => { goNftCollection(d.address, d.nftType, e) }} 
                            className={(d.address && location.pathname.includes(d.address)) || (d.urlName && location.pathname === `/collection/${d.urlName}`) ? 'selectNftItem' : ''}
                          >                            {
                              d.avatar && <ItemIcon src={d.avatar}/>
                            }
                            <ItemText>{d.nick}</ItemText>
                          </NftItem>
                        )
                      })
                    }
                  </NftList>
                )
              }
              <NavBarItem onClick={(e) => goCollectionList(3, e)} className={collectionIndex === 3 ? activeClassName : ''} style={{ paddingLeft: '54px' }}>
                <IconNav src={collectionIndex === 3 ? Partner_select : isDark ? Partner_dark : Partner} style={{ height: 24 }} />
                <TextTitle>Partner Shops</TextTitle>
                {
                  collectionIndex === 3 ?  
                  document.body.offsetWidth <= +MEDIA_WIDTHS.upToMedium ? (
                    <IconTriangle src={Triangle_down} style={{ height: 8 }} />
                  ) : (
                    <IconTriangle src={Triangle_right} style={{ height: 8 }} />
                  )
                  : document.body.offsetWidth <= +MEDIA_WIDTHS.upToMedium ? (
                    <IconTriangle src={Triangle_up} style={{ height: 8 }} />
                  ) : (
                    <IconTriangle src={Triangle_left} style={{ height: 8 }} />
                  )
                }
              </NavBarItem>
              {
                collectionIndex === 3 && document.body.offsetWidth <= +MEDIA_WIDTHS.upToMedium && (
                  <NftList className={'phoneNft'}>
                    {
                      collectionData.map((d , index) => {
                        return (
                          <NftItem 
                            key={index} 
                            onClick={(e) => { goNftCollection(d.address, d.nftType, e) }} 
                            className={(d.address && location.pathname.includes(d.address)) || (d.urlName && location.pathname === `/collection/${d.urlName}`) ? 'selectNftItem' : ''}
                          >       
                            {
                              d.avatar && <ItemIcon src={d.avatar}/>
                            }
                            <ItemText>{d.nick}</ItemText>
                          </NftItem>
                        )
                      })
                    }
                  </NftList>
                )
              }
              <NavBarItem onClick={(e) => goCollectionList(4, e)} className={collectionIndex === 4 ? activeClassName : ''} style={{ paddingLeft: '54px' }}>
                <IconNav src={collectionIndex === 4 ? GameNft_select : isDark ? GameNft_dark : GameNft} style={{ height: 24 }} />
                <TextTitle>Game Assets</TextTitle>
                {
                  collectionIndex === 4 ?  
                  document.body.offsetWidth <= +MEDIA_WIDTHS.upToMedium ? (
                    <IconTriangle src={Triangle_down} style={{ height: 8 }} />
                  ) : (
                    <IconTriangle src={Triangle_right} style={{ height: 8 }} />
                  )
                  : document.body.offsetWidth <= +MEDIA_WIDTHS.upToMedium ? (
                    <IconTriangle src={Triangle_up} style={{ height: 8 }} />
                  ) : (
                    <IconTriangle src={Triangle_left} style={{ height: 8 }} />
                  )
                }
              </NavBarItem>
              {
                collectionIndex === 4 && document.body.offsetWidth <= +MEDIA_WIDTHS.upToMedium && (
                  <NftList className={'phoneNft'}>
                    {
                      collectionData.map((d , index) => {
                        return (
                          <NftItem 
                            key={index} 
                            onClick={(e) => { goNftCollection(d.address, d.nftType, e) }} 
                            className={(d.address && location.pathname.includes(d.address)) || (d.urlName && location.pathname === `/collection/${d.urlName}`) ? 'selectNftItem' : ''}
                          >       
                            {
                              d.avatar && <ItemIcon src={d.avatar}/>
                            }
                            <ItemText>{d.nick}</ItemText>
                          </NftItem>
                        )
                      })
                    }
                  </NftList>
                )
              }
            </MenuElement>
          )
        }
        <NewGallery>
          <IconNav src={Gallery} style={{ height: 24 }} />
          {
            !isFold && (
              <AboutLink href={'https://gallery.bakeryswap.org/'} className={galleryAboutLink}>Bakery Gallery</AboutLink>
            )
          }
        </NewGallery>
        {/* <NavItem onClick={(e) => { hiddenNftCollection(e) }} to={'/ido'} className={location.pathname === '/ido' ? activeClassName : ''}>
          <IconNav src={location.pathname === '/ido' ? Launchpad_select : isDark ? Launchpad_dark : Launchpad} style={{ height: 24 }} />
          {
            !isFold && (
              <TextTitle>Launchpad</TextTitle>
            )
          }
        </NavItem> */}
        <NavItem onClick={(e) => { hiddenNftCollection(e) }} to={'/gamification/gameace'} className={location.pathname.indexOf('/gamification') > -1 ? activeClassName : ''}>
          <IconNav src={location.pathname === '/gamification/gameace' ? Game_select : isDark ? Game_dark : Game} style={{ height: 24 }} />
          {
            !isFold && (
              <TextTitle>Gamification</TextTitle>
            )
          }
          {
            !isFold && false && (
              <IconNew style={{ right: '50px' }} src={'/images/icon_hot' + (theme.darkMode ? '_light' : '') + '.svg'} width={24} />
            )
          }
        </NavItem>
        {
          false ? (
            <NavItem onClick={(e) => { hiddenNftCollection(e) }} to={'/eth2'} className={location.pathname === '/eth2' ? activeClassName : ''}>
              <IconNav src={location.pathname === '/eth2' ? Eth_select : Eth} style={{ height: 24 }} />
              {
                !isFold && (
                  <TextTitle>ETH2.0</TextTitle>
                )
              }
            </NavItem>
          ) : null
        }
        <AboutLink href={window.location.host.indexOf('bsc.bakeryswap.org') >= 0 ? 'https://info.bakeryswap.org' : 'https://bcswap-info.schail.com/'}>
          <IconNav src={isDark ? Info_dark : Info} style={{ height: 24 }} />
          {
            !isFold && (
              <TextTitle>Info</TextTitle>
            )
          }
        </AboutLink>
        <TriggerMenu onClick={(e) => { triggerContact(!isContact, e) }}>
          <IconNav src={isDark ? Contact_dark : Contact} style={{ height: 24 }} />
          {
            !isFold && (
              <TextTitle>Contact</TextTitle>
            )
          }
          {
            !isFold && (
              <IconTriangle src={!isContact ? Triangle_up : Triangle_down} style={{ height: 8 }} />
            )
          }
        </TriggerMenu>
        {
          !isFold && (
            <MenuElement className={isContact ? contactClassName : ''}>
              <AboutLink href={'https://twitter.com/bakery_swap'} style={{ paddingLeft: '54px', fontWeight: 500 }}>
                <IconNav src={isDark ? Twitter_dark : Twitter} style={{ height: 24 }} />
                <TextTitle>Twitter</TextTitle>
              </AboutLink>
              <AboutLink href={'https://medium.com/@BakerySwap'} style={{ paddingLeft: '54px', fontWeight: 500 }}>
                <IconNav src={isDark ? Medium_dark : Medium} style={{ height: 24 }} />
                <TextTitle>Medium</TextTitle>
              </AboutLink>
              <AboutLink href={'https://t.me/bakeryswap'} style={{ paddingLeft: '54px', fontWeight: 500  }}>
                <IconNav src={isDark ? Contact_dark : Contact} style={{ height: 24 }} />
                <TextTitle>Telegram</TextTitle>
              </AboutLink>
            </MenuElement>
          )
        }
      </NavElement>
      {
        !isFold && (
          <CollectionList className={hideCollection ? 'hideCollectionList' : ''}>
            <CollectionTitle onClick={() => hideCollectionFn()}>
              <IconExpand src={Triangle_left} style={{ height: 8 }}/>
              <TextTitle>{collectionTitle}</TextTitle>
            </CollectionTitle>
            <NftList>
              {
                collectionData.map((d , index) => {
                  return (
                    <NftItem 
                      key={index} 
                      onClick={(e) => { goNftCollection(d.address, d.nftType, e) }} 
                      className={(d.address && location.pathname.includes(d.address)) || (d.urlName && location.pathname === `/collection/${d.urlName}`) ? 'selectNftItem' : ''}
                    >
                      {
                        d.avatar && <ItemIcon src={d.avatar}/>
                      }
                      <ItemText>{d.nick}</ItemText>
                    </NftItem>
                  )
                })
              }
            </NftList>
          </CollectionList>
        )
      }
    </>
  )
}
